import { IApplication } from '../types';
import { IVacancyResult } from './vacancyResult';

// As duas ações finais (direcionar à Coordenação e gerar matrícula) valem para quem a
// Secretaria já aprovou: na convocação a aprovação dela é o deferimento.
export const isEligibleForFinalSteps = (application: IApplication): boolean => (
  application.status === 'Aprovado'
);

export const eligibleApplications = (applications: IApplication[]): IApplication[] => (
  applications.filter(isEligibleForFinalSteps)
);

// Os dois rótulos da coluna Resultado que ocupam uma das vagas da série.
const WITHIN_VACANCIES: IVacancyResult[] = ['Classificado', 'Classificado Excedente'];

// O direcionamento à Coordenação pede mais que a aprovação: ela só enxerga quem está
// dentro das vagas, então mandar um excedente geraria um e-mail com link que ela não
// consegue abrir. O backend recusa; aqui a seleção nem chega lá. A geração de matrícula
// continua valendo para o excedente aprovado.
export const isEligibleForCoordination = (
  application: IApplication,
  result?: IVacancyResult,
): boolean => (
  isEligibleForFinalSteps(application)
  && !!result
  && WITHIN_VACANCIES.indexOf(result) >= 0
);

export const coordinationApplications = (
  applications: IApplication[],
  results: { [applicationId: number]: IVacancyResult },
): IApplication[] => (
  applications.filter(application => isEligibleForCoordination(application, results[application.id]))
);
